import { getImageURL } from '../../../lib/utils/getImageURL'
import GhostButton from '../../../components/Buttons/GhostButton'
import TextInput from '../../../components/FormElements/TextInput'
import SelectInput from '../../../components/FormElements/SelectInput'
import { hoursOptions, timezonesOptions } from '../../../lib/utils/timezones'
import React from 'react'
import { Vendor } from '../../../lib/types/Vendor'
import { ReactComponent as DeleteIcon } from '../../../images/icons/action_delete.svg'
import { useFormContext } from 'react-hook-form'

export default function SourcePromax({
  vendor,
  onRemove,
  index,
}: {
  vendor: Vendor
  onRemove: (index: number) => void
  index: number
}) {
  const { watch } = useFormContext()

  const formValues = watch(`vendors[${index}]`)
  return (
    <div key={vendor.id} className={'flex flex-col gap-4 flex-1'}>
      <div className={'flex items-center gap-3'}>
        <div className={'flex items-center justify-center'}>
          <div className={'w-7 h-7 rounded-full flex'}>
            <img
              src={getImageURL(`images/vendors/${vendor.logo}`)}
              className={'object-contain'}
            />
          </div>
        </div>
        <span className={'font-bold text-xs text-blue-primary flex-1'}>
          {vendor.name}
        </span>
        <GhostButton
          transparent={true}
          onClick={(e) => {
            e.preventDefault()
            onRemove(index)
          }}>
          <DeleteIcon />
        </GhostButton>
      </div>
      <div>
        <div className={'w-1/2'}>
          <TextInput
            rules={{ required: 'This field is required' }}
            inverted
            placeholder={`Ex. ${vendor.name} import`}
            name={`vendors.${index}.source_name`}
            label={'Name your source'}
            info={'Give it a clear name so you remember it easily'}
          />
        </div>
      </div>
      <div className={'pb-10 border-b-2 flex justify-start items-center '}>
        <div className={'flex'}>
          <div className={'flex flex-row gap-5'}>
            <div className={'grow-0'}>
              <SelectInput
                required={'This field is required'}
                name={`vendors.${index}.fetch_frequency`}
                label={'Fetch frequency'}
                options={[{ label: 'Daily', value: 'daily' }]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
